import React from "react"; // add this
import { Provider } from "react-redux";
import "react-image-crop/dist/ReactCrop.css";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@mui/material/styles";
import { PersistGate } from "redux-persist/integration/react";

import "./index.scss";
import App from "./app";
import theme from "./common/constants/theme";
import reportWebVitals from "./reportWebVitals";
import { store, persistor } from "./redux/store";
import { posthog, PostHogProvider } from "./lib/posthog";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

type ProvidersProps = {
  children: React.ReactNode;
};

const Providers = ({ children }: ProvidersProps) => {
  return (
    <PostHogProvider client={posthog}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ThemeProvider theme={theme}>{children}</ThemeProvider>
        </PersistGate>
      </Provider>
    </PostHogProvider>
  );
};

const container = document.getElementById("root") as HTMLDivElement;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Providers>
      <App />
    </Providers>
  </React.StrictMode>,
);

serviceWorkerRegistration.register();
// If you want to start measuring performance in your app,

// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
